import { Component, EventEmitter, Input, Output } from "@angular/core";
import { PreLiquidacaoResto } from "eddydata-lib";

@Component({
  selector: 'app-pre-liquidacao-resto-consulta-dlg',
  templateUrl: './pre-liquidacao-resto-consulta-dlg.component.html'
})
export class PreLiquidacaoRestoConsultaDlgComponent {

  /**
   * Declaração de variáveis
   */
  @Input() public lista: PreLiquidacaoResto[];
  @Output() callback: EventEmitter<PreLiquidacaoResto> = new EventEmitter();

  public visualizar: boolean = false;


  /**
   * Construtor com as injeções de dependencias
   */
  constructor() { }

  public selecionarPre(pre: PreLiquidacaoResto): void {
    this.callback.emit(pre);
  }
}